import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, CardMedia, Link, Typography } from "@material-ui/core";
import useStyles from "./style.js";
import { useHistory } from "react-router-dom";

const SecondSection = () => {
  const classes = useStyles();
  let history = useHistory();

  function handleClick() {
    history.push("/aboutus/history");
    window.scrollTo(0, 0);
  }

  function handleClick2() {
    history.push("/ContentExp/");
    window.scrollTo(0, 0);
  }

  return (
    <Box component="div" className={classes.background}>
      <Box component="div" className={classes.card}>
        <Box component="div" className={classes.header}>
          <Typography variant="h6" color="inherit" className={classes.title}>
            Iluminándote desde 1979
          </Typography>
          <Box compoent="div" className={classes.whenUnderline}>
            {" "}
          </Box>
        </Box>
        <Typography p="true" className={classes.paragraph}>
          Manuel Ventura, guatemalteco y originario de Quiché, en 1979, decide
          adquirir 2 máquinas para fabricar veladoras de repuesto, y sin ninguna
          experiencia previa, inicia una empresa en el patio de su residencia en
          la zona 7 capitalina. El nombre de la empresa “Velas Jesús
          Nazareno”....
        </Typography>
        <Link component={RouterLink} to="#" className={classes.moreInfo}>
          <Button
            variant="contained"
            color="primary"
            className={classes.btnInfo}
            onClick={handleClick}
          >
            Ver más
          </Button>
        </Link>
      </Box>
      <Box component="div" className={classes.img}>
        <Box compoent="div" className={classes.bkgImg1} />
      </Box>
      <Box component="div" className={classes.img}>
        <Box compoent="div" className={classes.bkgImg2} />
      </Box>
      <Box component="div" className={classes.card}>
        <Box component="div" className={classes.header}>
          <Typography variant="h6" color="inherit" className={classes.title}>
            Fabricadas Responsablemente
          </Typography>
          <Box compoent="div" className={classes.howUnderline}>
            {" "}
          </Box>
        </Box>
        <Typography p="true" className={classes.paragraph}>
          Nuestras veladoras y candelas fabricadas responsablemente, por
          artesanos que mezclan métodos ancestrales y modernos, dando paso a
          productos de alta calidad y precio justo.
        </Typography>
        <Link component={RouterLink} to="#" className={classes.moreInfo}>
          <Button
            variant="contained"
            color="primary"
            className={classes.btnInfo}
            onClick={handleClick2}
          >
            Ver más
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default SecondSection;
